<template>
    <div class="go_panel_title">
        <div class="panel_hr_bar">
            <slot></slot>
        </div>
    </div>
</template>

<script>

    export default {
        name: "go-panel-title",
        computed: {

        },
        methods: {},
        mounted() {
        },
        components: {}
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/ctlVue/go-panel-title.vue